const defaultOptions = {
  type: "slide",
  gap: 10,
  pagination: false,
  arrows: true,
  keyboard: "focused",
  trimSpace: true,
  speed: 800,
  padding: {
    left: "20px",
    right: "20px",
  },
};

class DomaineCarousel extends HTMLElement {
  constructor() {
    super();
    this.width = this.dataset.width || false;
    window.addEventListener(
      "resize",
      debounce(this.handleResize.bind(this), 500)
    );
  }
  connectedCallback() {
    this.handleResize();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  initSlider(options) {
    if(!this.querySelector(".splide")) return;
    this.slider = new window.app.Splide(
      this.querySelector(".splide"),
      options
    ).mount();
  }

  destroySlider() {
    this.slider?.destroy();
  }

  updateSlidesWidth() {
    if (!this.width) return;
    const slides = this.querySelectorAll(".splide__slide");
    slides.forEach((slide) => {
      slide.style.width = this.width;
    });
  }

  removeSlidesWidth() {
    const slides = this.querySelectorAll(".splide__slide");
    slides.forEach((slide) => {
      slide.removeAttribute("style");
    });
  }
  handleResize() {
    this.destroySlider();
    if (window.innerWidth > window.defaultBps.mobile) {
      this.removeSlidesWidth();

      this.initSlider(
        this.desktopOptions
          ? this.desktopOptions
          : {
              ...defaultOptions,
              perPage: 4,
              perMove: 1,
              breakpoints: {
                1199: {
                  perPage: 3,
                  padding: {
                    left: "20px",
                    right: "20px",
                  },
                },
                836: {
                  perPage: 2,
                },
              },
            }
      );
    } else {
      this.initSlider(
        this.mobileOptions
          ? this.mobileOptions
          : {
              ...defaultOptions,
              autoWidth: true,
              padding: {
                left: "20px",
                right: "20px",
              },
            }
      );
      this.updateSlidesWidth();
    }
  }
}

customElements.define("domaine-carousel", DomaineCarousel);

customElements.define(
  "product-grid-carousel",
  class extends DomaineCarousel {
    constructor() {
      super();
      this.desktopOptions = {
        type: "slide",
        perPage: 3,
        perMove: 1,
        gap: 32,
        pagination: false,
        arrows: true,
        keyboard: "focused",
        trimSpace: true,
        speed: 800,
        padding: {
          left: "60px",
          right: "60px",
        },
        breakpoints: {
          1199: {
            perPage: 2,
            gap: 20,
            padding: {
              left: "20px",
              right: "20px",
            },
          },
        },
      };
      this.mobileOptions = {
        type: "slide",
        autoWidth: true,
        gap: 10,
        pagination: false,
        arrows: true,
        keyboard: "focused",
        trimSpace: true,
        speed: 800,
        padding: {
          left: "20px",
          right: "20px",
        },
      };
    }
  }
);
